import { DetailedUser } from '@mews-commander/data-access';
import { useGetAvatarSrc } from '@mews-commander/utils';
import { Avatar, Body, Stack, StackItem, Title } from '@optimus-web/core';
import { SecurityStatus } from './SecurityStatus';

interface UserDetailContentAvatarProps {
    user: DetailedUser;
}

export function UserDetailContentAvatar({ user }: UserDetailContentAvatarProps) {
    const getAvatarSrc = useGetAvatarSrc();

    return (
        <Stack spacing="200" itemAlignment="center" fill>
            <Avatar src={getAvatarSrc(user.imageId)} title={user.fullName || ''} size="extraLarge" />
            <StackItem grow>
                <Stack spacing="100" vertical itemAlignment="start">
                    <StackItem>
                        <Title level={3}>{user.fullName}</Title>
                        <Body variant="secondary">{user.email}</Body>
                    </StackItem>
                    <SecurityStatus securityFeatures={user.securityFeatures} />
                </Stack>
            </StackItem>
        </Stack>
    );
}
